import { buildApiUrl } from "./apiClientService";

export async function fetchMaintenancePublic() {
  const res = await fetch(buildApiUrl("/api/platform/maintenance"), {
    credentials: "omit",
  });
  if (!res.ok) {
    throw new Error("maintenance fetch failed");
  }
  return res.json();
}
